<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="row">
    <div class="col d-flex">
      <h1 class="fs-5 fw-bold mb-0">Redirect links</h1>
    </div>
  </div>

  <div class="d-flex gap-2">
    <a [routerLink]="'add'" *isGranted="['ROLE_API_REDIRECT_RULE_WRITE']" class="btn btn-primary fw-bold"><i
      class="bi bi-plus-lg me-2"></i>Add redirect link</a>
  </div>
</div>
<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="d-flex gap-3 align-items-center mb-3">
      <input type="text" [(ngModel)]="filters.values['name']" (ngModelChange)="onNameChange()" class="form-control"
             placeholder="Filter by name" style="padding: 11px;">

      <app-dropdown-select class="form-control" [(ngModel)]="filters.values['domainId']"
                           (onDropdownChange)="filters.onFilterChange()" placeholder="Filter by domain"
                           [multiple]="true">
        @for (availableDomain of availableDomains; track availableDomain) {
          <app-dropdown-select-option [value]="availableDomain.id">{{ availableDomain }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select class="form-control" [(ngModel)]="filters.values['productId']"
                           (onDropdownChange)="filters.onFilterChange()" placeholder="Filter by brand"
                           [multiple]="true">
        @for (product of products; track product) {
          <app-dropdown-select-option [value]="product.id">{{ product }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select class="form-control" [(ngModel)]="filters.values['lang']"
                           (onDropdownChange)="filters.onFilterChange()" placeholder="Filter by lang" [multiple]="true">
        @for (lang of languages; track lang) {
          <app-dropdown-select-option [value]="lang.isoCode">{{ lang.name }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()"
              title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead class="bg-tertiary">
        <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
          <th tableSorterHeader="id">ID</th>
          <th tableSorterHeader="name">Name</th>
          <th tableSorterHeader="domain.domain">Domain</th>
          <th tableSorterHeader="domain.product">Brand</th>
          <th tableSorterHeader="domain.lang">Lang</th>
          <th tableSorterHeader="identifier">Identifier</th>
          <th>Redirect URL</th>
          <th>Copy Parameters</th>
          <th>Enabled</th>
          <th>Hits</th>
          <th class="text-end">Action</th>
        </tr>
        </thead>
        <tbody>
          @for (redirectRule of redirectRules; track redirectRule.id) {
            <tr>
              <td>{{ redirectRule.id }}</td>
              <td>{{ redirectRule.name }}</td>
              <td>{{ redirectRule.domain?.domain }}</td>
              <td>{{ redirectRule.domain?.product }}</td>
              <td>
                @if (redirectRule.domain?.lang) {
                  <img [ngSrc]="langService.getFlag(redirectRule.domain.lang)" [alt]="redirectRule.domain?.lang"
                       class="country-flag"
                       width="24" height="24">
                } @else {
                  All
                }
              </td>
              <td>{{ redirectRule.identifier }}</td>
              <td><a [href]="redirectRule.redirectUrl" target="_blank" class="btn btn-sm btn-primary"><i
                class="bi bi-link"></i></a></td>
              <td>
                @if (redirectRule.copyQueryParameters) {
                  <span class="badge bg-success">Yes</span>
                }
                @if (!redirectRule.copyQueryParameters) {
                  <span class="badge bg-danger">No</span>
                }
              </td>
              <td>
                @if (redirectRule.enabled) {
                  <span class="badge bg-success">Enabled</span>
                }
                @if (!redirectRule.enabled) {
                  <span class="badge bg-danger">Disabled</span>
                }
              </td>
              <td>
                {{ redirectRule.hitCount }}
              </td>
              <td class="text-end">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[redirectRule.id]"><i
                  class="bi bi-pencil me-1"></i>Edit
                </a>
                <button class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(redirectRule)"><i
                  class="bi bi-trash"></i></button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
